/** The search debounce, in ms. */
export const SEARCH_DEBOUNCE_MS = 250;

/** At least two letters or digits - what the server accepts as `q`. */
export function searchable(v: string): string {
  const trimmed = v.trim();
  return trimmed.replace(/[^\p{L}\p{N}]+/gu, "").length >= 2 ? trimmed : "";
}

/** The store page's address for a query ("" = the rails). */
export function searchPath(q: string): string {
  return q ? `/?q=${encodeURIComponent(q)}` : "/";
}
